var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('HeaderView'),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.ours),expression:"ours"}]}),_c('FooterView',{on:{"oursMsg":_vm.getOurs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }